module.exports = __webpack_public_path__ + "static/img/card_icon_copy@2x.f36291ad.png";